import { RegExpUtil } from './RegExpUtil';
import { BrowserUtil } from './BrowserUtil';
export class PathUtil {
    static currentPath() {
        return BrowserUtil.getPath();
    }
    static prefixRegExp(langCode) {
        let prefix = '^/[A-Za-z]{2}/';
        if (langCode) {
            prefix = `^\/${langCode}\/`;
        }
        return prefix;
    }
    static isCatalogPage(path = PathUtil.currentPath(), langCode = 'ja') {
        let pattern = `${PathUtil.prefixRegExp(langCode)}co\/([0-9]*)\/catalog\/.*`;
        return RegExpUtil.test(pattern, path);
    }
    static isSearchCatalogPage(path = PathUtil.currentPath(), langCode = 'ja') {
        let pattern = `${PathUtil.prefixRegExp(langCode)}s\\/catalog.*`;
        return RegExpUtil.test(pattern, path);
    }
}
